import * as React from 'react';

interface Props {
  className?: string;
}

/**
 * A heading element intended to be use as a section heading for page content.
 *
 * @param props
 */
export const Title: React.FC<Props> = ({ children, className = '' }) => {
  return <h1 className={`text-2xl font-semibold ${className}`}>{children}</h1>;
};
